/* tslint:disable */

/**
 */
export class RpInvoiceForm {
    from_date?: string;
    to_date?: string;
    sign?: string;
}
